export const deploymentCatalog = [
  { deployment: 'commerce', audience: 'customer' },
  { deployment: 'cosmetic', audience: 'customer' },
  { deployment: 'hospitality', audience: 'customer' },
  { deployment: 'fnb', audience: 'customer' },
  { deployment: 'healthcare', audience: 'customer' },
  { deployment: 'healthcare_vn', audience: 'customer' },
  { deployment: 'office', audience: 'internal' },
  { deployment: 'productivity', audience: 'internal' },
  { deployment: 'gateway', audience: 'system' },
  { deployment: 'ketplus', audience: 'system' },
  { deployment: 'dev', audience: 'development' },
]

export const helpSolutions = [
  {
    deploymentSpecs: ['commerce'],
    group: 'business',
    label: 'Bán hàng',
    eyebrow: 'Thương mại',
    icon: 'commerce',
    slug: 'ban-hang',
    summary: 'Bán hàng, POS, sản phẩm, kho, mua hàng và kế toán.',
  },
  {
    deploymentSpecs: ['cosmetic'],
    group: 'business',
    label: 'Mỹ phẩm',
    eyebrow: 'Bán lẻ chuyên ngành',
    icon: 'cosmetic',
    slug: 'my-pham',
    summary: 'Bán hàng, CRM và quy trình chăm sóc khách hàng mỹ phẩm.',
  },
  {
    deploymentSpecs: [],
    group: 'business',
    label: 'KétSuite Ads',
    eyebrow: 'Quảng cáo đa nền tảng',
    icon: 'megaphone',
    slug: 'ads',
    summary: 'Ra quyết định quảng cáo bằng đơn mua thật, tối ưu AI và bảo vệ chất lượng chuyển đổi.',
  },
  {
    deploymentSpecs: ['hospitality'],
    group: 'business',
    label: 'Khách sạn',
    eyebrow: 'Lưu trú',
    icon: 'hospitality',
    slug: 'khach-san',
    summary: 'Lưu trú, đặt phòng, thanh toán và kết nối các kênh OTA.',
  },
  {
    deploymentSpecs: ['fnb'],
    group: 'business',
    label: 'Nhà hàng & F&B',
    eyebrow: 'Ẩm thực',
    icon: 'fnb',
    slug: 'fnb',
    summary: 'Bán hàng tại quầy, bếp, thực đơn và vận hành nhà hàng.',
  },
  {
    deploymentSpecs: ['healthcare', 'healthcare_vn'],
    group: 'healthcare',
    label: 'Quản trị nha khoa',
    eyebrow: 'Y tế · Nha khoa',
    icon: 'dental',
    slug: 'nha-khoa',
    summary: 'Lịch hẹn, hồ sơ nha khoa, điều trị và vận hành phòng khám.',
  },
  {
    deploymentSpecs: ['healthcare', 'healthcare_vn'],
    group: 'healthcare',
    label: 'Quản trị spa',
    eyebrow: 'Y tế · Wellness',
    icon: 'spa',
    slug: 'spa',
    summary: 'Lịch hẹn, liệu trình, dịch vụ wellness và chăm sóc khách hàng.',
  },
  {
    deploymentSpecs: ['healthcare', 'healthcare_vn'],
    group: 'healthcare',
    label: 'Quản trị bệnh viện',
    eyebrow: 'Y tế · Bệnh viện',
    icon: 'hospital',
    slug: 'benh-vien',
    summary: 'Cơ sở, hồ sơ bệnh nhân, khám chữa bệnh và vận hành bệnh viện.',
  },
]

export const helpGroups = [
  {
    id: 'business',
    label: 'Kinh doanh & dịch vụ',
    eyebrow: '5 giải pháp Két Việt',
    summary: 'Chọn đúng mô hình để xem tài liệu theo cấu hình vận hành bạn đang dùng.',
    items: helpSolutions.filter(({ group }) => group === 'business'),
  },
  {
    id: 'healthcare',
    label: 'Y tế',
    eyebrow: '3 ngành chuyên biệt',
    summary: 'Chọn ngành phù hợp với loại hình cơ sở và quy trình vận hành của bạn.',
    items: helpSolutions.filter(({ group }) => group === 'healthcare'),
  },
]
